import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BusinessContactDialogComponent } from '../business-contact-dialog/business-contact-dialog.component';

@Component({
  selector: 'app-page-bottom',
  templateUrl: './page-bottom.component.html',
  styleUrls: ['./page-bottom.component.scss'],
})
export class PageBottomComponent {
  constructor(private dialog: MatDialog) {}

  showBusiness() {
    this.dialog.open(BusinessContactDialogComponent, {
      panelClass: 'app-dialog',
      autoFocus: false,
    });
  }

  gotoFriend(link: any) {
    window.open(link);
  }
}
